import type {
  AmericanTrailingReturns,
  BrazilianTrailingReturns,
} from "components/issuers/trailingReturns/TrailingReturns";
import type { IBrazilianRealEstateFundIssuer } from "types/graphqlTypes";

export default function getTrailingReturns(
  issuer:
    | BrazilianTrailingReturns
    | AmericanTrailingReturns
    | Pick<IBrazilianRealEstateFundIssuer, "__typename" | "trailingReturns">,
) {
  if (issuer.__typename === "BrazilianRealEstateFundIssuer") {
    return issuer.trailingReturns;
  }

  const securitiesWithTrailingReturns = issuer.securities.filter((node) => node.trailingReturns);

  if (securitiesWithTrailingReturns.length === 0) {
    return null;
  }

  const securitiesSorted = securitiesWithTrailingReturns.sort(
    (a, b) => (b.trailingReturns?.numberOfTrades || 0) - (a.trailingReturns?.numberOfTrades || 0),
  );

  return securitiesSorted[0].trailingReturns;
}
